/**
 * Dummy data — 예약 (Reservations)
 * API 명세 필드명/타입 100% 동일
 *
 * ReservationResponse 필드:
 *   id, reservation_number, service_type, direction, departure, destination,
 *   reservation_date, start_time, passengers, base_price, total_price, status, created_at
 *
 * ReservationDetail 확장 필드:
 *   departure_lat, departure_lng, destination_lat, destination_lng,
 *   flight_number, flight_arrival_time, terminal,
 *   booker_name, booker_phone, booker_email, memo
 *
 * status enum: pending | confirmed | driver_arrived | driving | drive_completed | completed | cancelled | refunded | no_show
 * service_type enum: airport | golf | ski | hospital | pet | business
 * direction: pickup | sending (공항 서비스용)
 */

const reservations = [
  {
    id: 1,
    reservation_number: 'VVT-2026020501',
    service_type: 'airport',
    direction: 'sending',
    departure: '서울특별시 관악구 관악로 1',
    destination: '인천국제공항 제1터미널',
    reservation_date: '2026-02-05',
    start_time: '08:00',
    passengers: 2,
    base_price: 198000,
    total_price: 198000,
    status: 'pending',
    created_at: '2026-01-29T20:40:00',
    // Detail 확장 필드
    departure_lat: 37.4783,
    departure_lng: 126.9516,
    destination_lat: 37.4602,
    destination_lng: 126.4407,
    flight_number: 'KE651',
    flight_arrival_time: null,
    terminal: 'T1',
    booker_name: '김민수',
    booker_phone: '010-1234-5678',
    booker_email: 'minsu@gmail.com',
    memo: '',
  },
  {
    id: 2,
    reservation_number: 'VVT-2026020601',
    service_type: 'golf',
    direction: null,
    departure: '서울특별시 강남구 강남대로 396',
    destination: '블루원 용인 CC',
    reservation_date: '2026-02-06',
    start_time: '06:00',
    passengers: 4,
    base_price: 250000,
    total_price: 300000,
    status: 'confirmed',
    created_at: '2026-01-30T14:20:00',
    departure_lat: 37.4979,
    departure_lng: 127.0276,
    destination_lat: 37.2636,
    destination_lng: 127.1989,
    flight_number: null,
    flight_arrival_time: null,
    terminal: null,
    booker_name: '이지은',
    booker_phone: '010-2345-6789',
    booker_email: 'jieun@gmail.com',
    memo: '새벽 출발, 왕복',
  },
  {
    id: 3,
    reservation_number: 'VVT-2026020701',
    service_type: 'ski',
    direction: null,
    departure: '서울특별시 송파구 올림픽로 300',
    destination: '비발디파크',
    reservation_date: '2026-02-07',
    start_time: '05:30',
    passengers: 3,
    base_price: 180000,
    total_price: 216000,
    status: 'driving',
    created_at: '2026-02-01T10:00:00',
    departure_lat: 37.5126,
    departure_lng: 127.1025,
    destination_lat: 37.6484,
    destination_lng: 127.6820,
    flight_number: null,
    flight_arrival_time: null,
    terminal: null,
    booker_name: '박서준',
    booker_phone: '010-3456-7890',
    booker_email: 'sjpark@gmail.com',
    memo: '',
  },
  {
    id: 4,
    reservation_number: 'VVT-2026020801',
    service_type: 'hospital',
    direction: null,
    departure: '서울특별시 용산구 한강대로 405',
    destination: '서울아산병원',
    reservation_date: '2026-02-08',
    start_time: '09:00',
    passengers: 2,
    base_price: 150000,
    total_price: 150000,
    status: 'completed',
    created_at: '2026-02-02T11:30:00',
    departure_lat: 37.5547,
    departure_lng: 126.9707,
    destination_lat: 37.5268,
    destination_lng: 127.1085,
    flight_number: null,
    flight_arrival_time: null,
    terminal: null,
    booker_name: '최유나',
    booker_phone: '010-4567-8901',
    booker_email: 'yuna@gmail.com',
    memo: '휠체어 필요',
  },
  {
    id: 5,
    reservation_number: 'VVT-2026020901',
    service_type: 'pet',
    direction: null,
    departure: '서울특별시 마포구 양화로 160',
    destination: '서울특별시 서초구 서초대로 398',
    reservation_date: '2026-02-09',
    start_time: '14:00',
    passengers: 1,
    base_price: 120000,
    total_price: 120000,
    status: 'completed',
    created_at: '2026-02-03T09:00:00',
    departure_lat: 37.5571,
    departure_lng: 126.9236,
    destination_lat: 37.4917,
    destination_lng: 127.0073,
    flight_number: null,
    flight_arrival_time: null,
    terminal: null,
    booker_name: '정하늘',
    booker_phone: '010-5678-9012',
    booker_email: 'haneul@gmail.com',
    memo: '대형견 1마리',
  },
  {
    id: 6,
    reservation_number: 'VVT-2026021001',
    service_type: 'business',
    direction: null,
    departure: '서울특별시 영등포구 국제금융로 10',
    destination: '서울특별시 강남구 테헤란로 152',
    reservation_date: '2026-02-10',
    start_time: '07:00',
    passengers: 1,
    base_price: 100000,
    total_price: 100000,
    status: 'cancelled',
    created_at: '2026-02-04T18:00:00',
    departure_lat: 37.5252,
    departure_lng: 126.9259,
    destination_lat: 37.5012,
    destination_lng: 127.0396,
    flight_number: null,
    flight_arrival_time: null,
    terminal: null,
    booker_name: '한지민',
    booker_phone: '010-6789-0123',
    booker_email: 'jimin@company.com',
    memo: '',
  },
  {
    id: 7,
    reservation_number: 'VVT-2026021101',
    service_type: 'airport',
    direction: 'pickup',
    departure: '인천국제공항 제2터미널',
    destination: '서울특별시 중구 을지로 30',
    reservation_date: '2026-02-11',
    start_time: '15:00',
    passengers: 3,
    base_price: 198000,
    total_price: 198000,
    status: 'confirmed',
    created_at: '2026-02-05T12:00:00',
    departure_lat: 37.4602,
    departure_lng: 126.4407,
    destination_lat: 37.5660,
    destination_lng: 126.9784,
    flight_number: 'OZ202',
    flight_arrival_time: '2026-02-11T14:30:00',
    terminal: 'T2',
    booker_name: 'John Smith',
    booker_phone: '010-7890-1234',
    booker_email: 'john@gmail.com',
    memo: '영어 가능 기사 요청',
  },
];

/* ── Dummy service functions ── */

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** 목록 조회 (서비스: GET /api/reservations) */
export const getReservations = async (params = {}) => {
  await delay(300);
  let filtered = [...reservations];

  // status 필터 (upcoming/completed/cancelled/all)
  if (params.status && params.status !== 'all') {
    const statusMap = {
      upcoming: ['pending', 'confirmed'],
      completed: ['completed'],
      cancelled: ['cancelled'],
    };
    const allowed = statusMap[params.status] || [params.status];
    filtered = filtered.filter((r) => allowed.includes(r.status));
  }

  if (params.service_type) {
    filtered = filtered.filter((r) => r.service_type === params.service_type);
  }

  // ReservationResponse 필드만 반환 (Detail 필드 제외)
  return filtered.map(toResponse);
};

/** 예약번호로 조회 (비회원: GET /api/reservations/lookup) */
export const lookupReservation = async ({ reservation_number, email, phone }) => {
  await delay(200);
  const found = reservations.find((r) => {
    if (r.reservation_number !== reservation_number) return false;
    if (email && r.booker_email !== email) return false;
    if (phone && r.booker_phone !== phone) return false;
    return true;
  });
  if (!found) throw new Error('예약을 찾을 수 없습니다');
  return { ...found };
};

/** 상세 조회 (GET /api/reservations/:id) */
export const getReservationById = async (id) => {
  await delay(200);
  const found = reservations.find((r) => r.id === Number(id));
  if (!found) throw new Error('예약을 찾을 수 없습니다');
  return { ...found };
};

/** GET /api/reservations/:id/receipt-url — 더미는 매출전표 없음 → 인쇄 폴백 */
export const getReservationReceiptUrl = async () => {
  await delay(100);
  return { receipt_url: null };
};

/** 예약 생성 (POST /api/reservations) */
export const createReservation = async (body) => {
  await delay(400);
  const newRes = {
    id: reservations.length + 1,
    reservation_number: `VVT-${Date.now()}`,
    service_type: body.service_type,
    direction: body.direction || null,
    departure: body.departure_address || null,
    destination: body.destination_address || null,
    reservation_date: body.pickup_date ? body.pickup_date.slice(0, 10) : null,
    start_time: body.pickup_time || null,
    passengers: body.passenger_count || 1,
    base_price: 0,
    total_price: 0,
    status: 'pending',
    created_at: new Date().toISOString(),
    departure_lat: body.departure_lat || null,
    departure_lng: body.departure_lng || null,
    destination_lat: body.destination_lat || null,
    destination_lng: body.destination_lng || null,
    flight_number: body.flight_number || null,
    flight_arrival_time: null,
    terminal: body.terminal || null,
    booker_name: body.booker_name || null,
    booker_phone: body.booker_phone || null,
    booker_email: body.booker_email || null,
    memo: body.special_requests || '',
  };
  reservations.push(newRes);
  return toResponse(newRes);
};

/** 예약 취소 (PUT /api/reservations/:id/cancel) */
export const cancelReservation = async (id) => {
  await delay(300);
  const found = reservations.find((r) => r.id === Number(id));
  if (!found) throw new Error('예약을 찾을 수 없습니다');
  found.status = 'cancelled';
  return { message: '예약이 취소되었습니다' };
};

/** 재예약 (POST /api/reservations/:id/rebook) */
export const rebookReservation = async (id) => {
  await delay(400);
  const found = reservations.find((r) => r.id === Number(id));
  if (!found) throw new Error('예약을 찾을 수 없습니다');
  const rebooked = { ...found, id: reservations.length + 1, reservation_number: `VVT-${Date.now()}`, status: 'pending', created_at: new Date().toISOString() };
  reservations.push(rebooked);
  return toResponse(rebooked);
};

/* ── 관리자용 (Admin) ── */

/** 관리자 목록 (GET /api/admin/reservations) — 페이지네이션 */
export const getAdminReservations = async (params = {}) => {
  await delay(300);
  let filtered = [...reservations];

  if (params.status) filtered = filtered.filter((r) => r.status === params.status);
  if (params.service_type) filtered = filtered.filter((r) => r.service_type === params.service_type);
  if (params.user_id) filtered = filtered.filter((r) => r.id === params.user_id);

  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;

  return {
    items: filtered.slice(start, start + size).map(toResponse),
    total: filtered.length,
    page,
    size,
    pages: Math.ceil(filtered.length / size),
  };
};

/** 관리자 상세 조회 (GET /api/admin/reservations/:id) */
export const getAdminReservationById = async (id) => {
  await delay(200);
  const found = reservations.find((r) => r.id === Number(id));
  if (!found) throw new Error('예약을 찾을 수 없습니다');
  const SERVICE_LABELS = { airport: '프라이빗 이동 - 공항', golf: '프라이빗 이동 - 골프', ski: '프라이빗 이동 - 리조트', hospital: '프라이빗 이동 - 병원', pet: '프라이빗 이동 - 반려동물', business: '프라이빗 이동 - 비즈니스' };
  const DIRECTION_LABELS = { pickup: '공항 → 목적지', sending: '출발지 → 공항' };
  return {
    ...found,
    service_label: SERVICE_LABELS[found.service_type] || `프라이빗 이동 - ${found.service_type}`,
    direction_label: DIRECTION_LABELS[found.direction] || `${found.departure} → ${found.destination}`,
    route: {
      label: DIRECTION_LABELS[found.direction] || `${found.departure} → ${found.destination}`,
      from: { label: '출발지', name: found.departure, address: found.departure, detail: '' },
      to: { label: '도착지', name: found.destination, address: found.destination, detail: found.terminal ? `${found.terminal}` : '' },
    },
    customer: {
      name: found.booker_name,
      phone: found.booker_phone,
      email: found.booker_email,
      membership: found.user_id ? '회원' : '비회원',
    },
    options: [
      { label: '이용 인원', value: `${found.passengers}명`, price: '' },
    ],
    payment: {
      date: found.created_at ? new Date(found.created_at).toLocaleString('ko-KR') : '-',
      method: '',
      amount: found.total_price ? found.total_price.toLocaleString() : '0',
    },
    additional_charges: found.status === 'drive_completed' || found.status === 'completed' ? [
      { label: '초과 시간', value: '30분', amount: 25000 },
    ] : [],
    additional_total: found.status === 'drive_completed' || found.status === 'completed' ? 25000 : 0,
  };
};

/** 관리자 상태 변경 (PUT /api/admin/reservations/:id/status) */
export const updateAdminReservationStatus = async (id, status, extraData) => {
  await delay(300);
  const found = reservations.find((r) => r.id === Number(id));
  if (!found) throw new Error('예약을 찾을 수 없습니다');
  found.status = status;
  return { message: '상태가 변경되었습니다' };
};

/** 관리자 메모 수정 (PUT /api/admin/reservations/:id/memo) */
export const updateAdminReservationMemo = async (id, memo) => {
  await delay(200);
  const found = reservations.find((r) => r.id === Number(id));
  if (!found) throw new Error('예약을 찾을 수 없습니다');
  found.memo = memo;
  return { message: '메모가 저장되었습니다' };
};

/** 기사 정보(연락처·차량번호) 입력 (PUT /api/admin/reservations/:id/driver-info) */
export const updateAdminReservationDriverInfo = async (id, { driverPhone, vehicleNumber }) => {
  await delay(200);
  const found = reservations.find((r) => r.id === Number(id));
  if (found) {
    if (driverPhone !== undefined) found.driver_phone = driverPhone;
    if (vehicleNumber !== undefined) found.vehicle_number = vehicleNumber;
  }
  return { message: '기사 정보가 저장되었습니다' };
};

/** 예약 차단 해제 (DELETE /api/admin/reservations/:id/block) */
export const unblockReservation = async (id) => {
  await delay(200);
  return { message: '차단이 해제되었습니다' };
};

/** GET /api/availability/check — 예약 가용성 체크 */
export const checkAvailability = async ({ service_type, date, start_time, end_time, passengers }) => {
  await delay(300);
  // 더미: 20% 확률로 예약 불가 시뮬레이션
  const isFullyBooked = Math.random() < 0.2;
  return { available: !isFullyBooked, service_type, date };
};

/** POST /api/admin/reservations/:id/extra-charge — 추가 요금 등록 */
export const createAdminExtraCharge = async (id, data) => {
  await delay(300);
  return { success: true };
};

/** PUT /api/admin/reservations/:id/buffer-after — buffer_after 실시간 조절 (BugHerd #37) */
export const updateAdminReservationBufferAfter = async (id, minutes) => {
  await delay(200);
  return { message: `buffer_after ${minutes}분 적용 완료` };
};

/* ── Helper: ReservationResponse 필드만 추출 ── */
function toResponse(r) {
  return {
    id: r.id,
    reservation_number: r.reservation_number,
    service_type: r.service_type,
    direction: r.direction,
    departure: r.departure,
    destination: r.destination,
    reservation_date: r.reservation_date,
    start_time: r.start_time,
    passengers: r.passengers,
    base_price: r.base_price,
    total_price: r.total_price,
    status: r.status,
    created_at: r.created_at,
  };
}
